import React, { Suspense, useState } from 'react';
import * as Sentry from '@sentry/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { BrowserTracing } from '@sentry/tracing';

import { ToastContainer } from 'react-toastify';

import './App.css';
import { ApolloClient, ApolloProvider } from '@apollo/client';

import { clientPromise } from './http/apollo.config';
import { SessionProvider } from './context/Session';
import { ThemeProvider } from './context/Theme';
import { AuthProvider } from './context/Auth';
import { UserStrategiesProvider } from './context/UserStrategies';
import { NotificationsProvider } from './context/Notifications';
import { ChatProvider } from './context/Chat';
import { ModalPage, ModalProvider } from './context/Modal';

import { TutorialProvider } from './context/Tutorial';
import { AppRoutes } from './AppRoutes';
import { MarketsProvider } from './components/Market/MarketContext';
import { EnvLabel } from './components/EnvLabel/EnvLabel';
import { MembershipProvider } from './context/Membership';
import { MobileProvider } from './context/Mobile';
import Splash from './components/Splash/Splash';
import { SidebarProvider } from './context/Sidebar';

// if (process.env.REACT_APP_ENV !== 'dev') {
//   Sentry.init({
//     dsn: process.env.REACT_APP_SENTRY_DSN,
//     integrations: [new BrowserTracing()],
//     environment: process.env.REACT_APP_ENV,
//     release: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VER}`,
//     debug: process.env.REACT_APP_ENV !== 'production',
//     tracesSampleRate: process.env.REACT_APP_ENV === 'production' ? 0.2 : 1,
//   });
// }

function App() {
  const [authClient, setAuthClient] = useState<ApolloClient<any>>();

  clientPromise.then((client) => setAuthClient(client));

  return authClient ? (
    <ApolloProvider client={authClient}>
      <Suspense fallback={<Splash />}>
        <Router>
          <EnvLabel />
          <ToastContainer
            pauseOnHover={true}
            position={'top-center'}
            autoClose={3000}
            hideProgressBar={true}
            closeOnClick={true}
            draggable={true}
            theme={'colored'}
          />
          <SessionProvider>
            <AuthProvider>
              <UserStrategiesProvider>
                <MembershipProvider>
                  <ThemeProvider>
                    <MobileProvider>
                      <ChatProvider>
                        <TutorialProvider>
                          <ModalProvider>
                            <SidebarProvider>
                              <NotificationsProvider>
                                <ModalPage />
                                <MarketsProvider>
                                  <AppRoutes />
                                </MarketsProvider>
                              </NotificationsProvider>
                            </SidebarProvider>
                          </ModalProvider>
                        </TutorialProvider>
                      </ChatProvider>
                    </MobileProvider>
                  </ThemeProvider>
                </MembershipProvider>
              </UserStrategiesProvider>
            </AuthProvider>
          </SessionProvider>
        </Router>
      </Suspense>
    </ApolloProvider>
  ) : (
    <></>
  );
}

export default Sentry.withProfiler(App);
